import type { ReactNode } from "react";

import styles from "./PageHeader.module.css";

interface PageHeaderProps {
  /** Small mono uppercase label above the title (e.g. "Approvals", "Section 09"). */
  eyebrow?: ReactNode;
  title: ReactNode;
  /** A sentence of context under the title. Omit rather than pass an empty string. */
  intro?: ReactNode;
}

/**
 * The one "eyebrow + h1 + intro" pattern every top-level screen uses. Manual
 * and Approvals pages already followed this; Access Management and Restricted
 * Sections instead rendered their own smaller h2 — a real screen-reader
 * document-outline inconsistency (some top-level screens had no h1 at all).
 * This is the single source now.
 */
export function PageHeader({ eyebrow, title, intro }: PageHeaderProps) {
  return (
    <>
      {eyebrow && <div className={styles.eyebrow}>{eyebrow}</div>}
      <h1 className={styles.title}>{title}</h1>
      {intro && <p className={styles.intro}>{intro}</p>}
    </>
  );
}
